import { EProfileStrengthForm } from '../../services/profileTypes'

export type TProfileStrengthEvent = {
    formName: EProfileStrengthForm
    index?: number
}

export const PROFILE_STRENGTH_EVENT_NAME = 'PROFILE_STRENGTH_OPEN_FORM'

export enum EStrength {
    beginner = 'Beginner',
    intermediate = 'Intermediate',
    expert = 'Expert',
    allStar = 'All Star'
}

export interface IStrengthOption {
    id: number
    name: EStrength
}

export const strengthOption: IStrengthOption[] = [
    // { id: 0, name: 'Unfinished' },
    { id: 1, name: EStrength.beginner },
    { id: 2, name: EStrength.intermediate },
    { id: 3, name: EStrength.expert },
    { id: 4, name: EStrength.allStar }
]

export const MAX_LEVEL_ID = 4

export type TSuggestionItem = {
    block: EProfileStrengthForm
    item: string
    value: number
    index: number
}

export type TProfileLevelItem = {
    level: number
    passedPoints: number
    totalPoints: number
    status: string
    profileStrength: number
}

export type TSuggestion = {
    acquiredLevel: number
    suggestions: TSuggestionItem[]
}

export const BLOCK_MAPPING = {
    [EProfileStrengthForm.BASIC_INFO]: {
        name: 'Basic Information'
    },
    [EProfileStrengthForm.WORK_HISTORY]: {
        name: 'Work History'
    },
    [EProfileStrengthForm.CONTACT_INFO]: {
        name: 'Contact Information'
    },
    [EProfileStrengthForm.SKILLS]: {
        name: 'Skills'
    },
    [EProfileStrengthForm.REFERENCES]: {
        name: 'References'
    },
    [EProfileStrengthForm.WORKING_PREFERENCES]: {
        name: 'Working Preference'
    },
    [EProfileStrengthForm.SUMMARY]: {
        name: 'Summary'
    },
    [EProfileStrengthForm.LANGUAGES]: {
        name: 'Languages'
    },
    [EProfileStrengthForm.EDUCATIONS]: {
        name: 'Education'
    }
}
